import React from 'react';
import { Image, Box } from '@chakra-ui/react';
import { QUICK_CASH_CONFIG } from '../Games/ScratchCardConfigs';
import BaseCardComponent from '../BaseCardComponent';

/**
 * QuickCashCard Component
 * 
 * A dedicated component for rendering the QUICK CASH scratch card
 * using the BaseCardComponent for consistent layout and behavior.
 */
const QuickCashCard = ({ 
  isPreview = false, 
  onPlay,
  onBuy,
  gameState = null 
}) => {
  return (
    <BaseCardComponent
      config={QUICK_CASH_CONFIG}
      isPreview={isPreview}
      onPlay={onPlay}
      onBuy={onBuy}
      gameState={gameState}
      customSymbol="⭐"
    />
  );
};

export default QuickCashCard;
